import { InfoCircleFilled } from "@ant-design/icons"
import { Alert, Col, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface HeaderProps {
    invoiceTypeLabel: string
    invoiceTypeCode: number
    invoiceNumber: string | undefined
    invoiceDate: string
}

export const EInvoiceHeader = ({ invoiceTypeLabel, invoiceTypeCode, invoiceNumber, invoiceDate }: HeaderProps) => {
    const { t } = useTranslation()
    return (
        <>
            <img src={"/images/finwayLogo.png"} className="w-120 sm:w-140 mt-4" alt={"finway"} />
            <Alert message={t("label:no_liability_message")} type="info" className="rounded-lg" icon={<InfoCircleFilled />} showIcon />
            <Row justify="space-between" align="top" className="text-black text-base">
                <Col>
                    <Row gutter={16}>
                        <Col>
                            <span className="font-medium">
                                {invoiceTypeLabel} ({invoiceTypeCode})
                            </span>
                        </Col>
                        <Col>
                            <span className="font-medium">Nr. {invoiceNumber || "N/A"}</span>
                        </Col>
                        <Col>
                            <span className="font-medium">Date {invoiceDate}</span>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}
